import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ImagePlaceholder } from 'Components/frameworks/image-placeholder/ImagePlaceholder';
type ImageInvalidProps = {
  ratio?: number;
  className?: string;
};
export const ImageInvalid = ({ ratio = 0.75, className }: ImageInvalidProps) => (
  <ImagePlaceholder aspectRatio={ratio * 100} className={className}>
    <span className="flex h-full items-center justify-center overflow-hidden bg-lightGrey p-5 text-center">
      <Icon className="text-lightGrey opacity-25" name={ICONS.TRIDENT1} width="4em" />
    </span>
  </ImagePlaceholder>
);
